import React from "react";
import "./ButtonsLoader.css";

const ButtonsLoader = () => {
  return (
    <div className="ring-loader">
      <div className="ring"></div>
      <div className="dot"></div>
    </div>
  );
};

export default ButtonsLoader;
